import { AIQuotaSnapshotSchema, AIQuotaUpdateResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type AIQuotaSnapshotInput = z.input<typeof AIQuotaSnapshotSchema>;
export type AIQuotaSnapshotOutput = z.output<typeof AIQuotaSnapshotSchema>;

export function serializeAIQuotaSnapshot(payload: AIQuotaSnapshotInput): AIQuotaSnapshotOutput {
  return AIQuotaSnapshotSchema.parse(payload);
}

export type AIQuotaUpdateResponseInput = z.input<typeof AIQuotaUpdateResponseSchema>;
export type AIQuotaUpdateResponseOutput = z.output<typeof AIQuotaUpdateResponseSchema>;

export function serializeAIQuotaUpdateResponse(payload: AIQuotaUpdateResponseInput): AIQuotaUpdateResponseOutput {
  return AIQuotaUpdateResponseSchema.parse(payload);
}
